var NATIVE_SYMBOL = require('../internals/native-symbol');

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/use-symbol-as-uid.js
// module id = 1003
// module chunks = 1